module.exports = __webpack_public_path__ + "img/draw.ca9b7a4e.png";